module.exports = __webpack_public_path__ + "img/logo_circle.788f3382.png";